__turbopack_context__.v({
  "className": "space_grotesk_590fd37e-module__Yn3fQa__className",
  "variable": "space_grotesk_590fd37e-module__Yn3fQa__variable",
});
